export default {"src":"/_next/static/media/reptiles.d80926d2.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};